export { default } from "./DataPermissionsPage";
